import type { TrigKey } from './keys';

export const pt: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matemática · Trigonometria',
  'panel.experiment': 'Experimento',
  'panel.params': 'Parâmetros',
  'panel.scene': 'Escolha um experimento',
  'experiment.right-triangle.label': 'Triângulo retângulo',
  'experiment.unit-circle.label': 'Círculo unitário',
  'experiment.wave-studio.label': 'Estúdio de ondas',
  'experiment.identity-playground.label': 'Identidades',
  'experiment.triangle-solver.label': 'Resolvedor de triângulos',
  'experiment.circular-polar.label': 'Circular e polar',
  'hint.line1': 'Arraste pontos e mova os controles.',
  'hint.line2': 'O conteúdo educativo vive na geometria, não no texto.',
  'rt.angle.a': 'Ângulo A',
  'rt.angle.b': 'Ângulo B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radianos',
  'rt.show.sin': 'sen',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Encaixar em 30°/45°/60°',
  'uc.units': 'Unidades',
  'uc.show.sin': 'sen',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Mostrar ASTC',
  'uc.snap.common': 'Encaixar em ângulos comuns',
  'uc.angle.value': '∠',
  'uc.units.deg': 'graus',
  'uc.units.rad': 'rad',
  'uc.units.both': 'graus+rad',
  'ws.fn': 'Função',
  'ws.fn.sin': 'sen',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Frequência',
  'ws.phase': 'C — Defasagem',
  'ws.shift': 'D — Deslocamento vertical',
  'ws.rform.toggle': 'Forma R',
  'ws.rform.a': 'a (coef. sen)',
  'ws.rform.b': 'b (coef. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Resetar',
  'ws.base': 'Mostrar curva base',
  'ip.id.pythagorean': 'Pitagórica',
  'ip.id.reciprocal': 'Recíproca',
  'ip.id.quotient': 'Quociente',
  'ip.id.sum': 'Soma',
  'ip.id.difference': 'Diferença',
  'ip.id.double': 'Ângulo duplo',
  'ip.id.half': 'Ângulo metade',
  'ip.play': 'Reproduzir',
  'ip.pause': 'Pausar',
  'ip.step': 'Passo',
  'ip.reset': 'Resetar',
  'ip.proof.pythagorean.summary': 'sen²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sen θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sen θ / cos θ',
  'ip.proof.sum.summary': 'sen(A+B) = sen A cos B + cos A sen B',
  'ip.proof.difference.summary': 'sen(A−B) = sen A cos B − cos A sen B',
  'ip.proof.double.summary': 'sen 2θ = 2 sen θ cos θ',
  'ip.proof.half.summary': 'sen(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Em v2 — esta prova precisa de uma construção mais elaborada.',
  'ts.area': 'Área',
  'ts.sineRule': 'Lei dos senos',
  'ts.cosineRule': 'Lei dos cossenos',
  'ts.ambiguous.toggle': 'Mostrar triângulo fantasma se ambíguo',
  'ts.reset': 'Resetar para equilátero',
  'ts.snap.integers': 'Encaixar em inteiros',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Lados',
  'ts.section.angles': 'Ângulos',
  'ts.section.sineRule': 'Lei dos senos',
  'ts.section.cosineRule': 'Lei dos cossenos',
  'ts.section.area': 'Área',
  'cp.omega': 'Velocidade angular',
  'cp.plot.y': 'Plotar y (sen)',
  'cp.plot.x': 'Plotar x (cos)',
  'cp.polar.label': 'Figura polar',
  'cp.polar.circle': 'Círculo (r = 1)',
  'cp.polar.rose': 'Rosa (r = sen 3θ)',
  'cp.polar.cardioid': 'Cardioide (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Aprox. de ângulo pequeno (sen x ≈ x)',
  'cp.play': 'Reproduzir',
  'cp.pause': 'Pausar',
  'cp.reset': 'Resetar',
  'cp.step': 'Passo π/12',
};
